/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Compare_Row_Dwg_CcInputs */

const en_cad_compare_row_dwg_cc = /** @type {(inputs: Cad_Compare_Row_Dwg_CcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opens R13-2018, saves 2000-2018`)
};

/**
* | output |
* | --- |
* | "Opens R13-2018, saves 2000-2018" |
*
* @param {Cad_Compare_Row_Dwg_CcInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_compare_row_dwg_cc = /** @type {((inputs?: Cad_Compare_Row_Dwg_CcInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Compare_Row_Dwg_CcInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_compare_row_dwg_cc(inputs)
});
export { cad_compare_row_dwg_cc as "cad.compare.row_dwg_cc" }